// Packages
import { useContext } from "react";

// Context
import { Language } from "../../Language/Language";

// Components

// Elements
import { Container, Disclaimer, Logo } from "./Footer.elements";

function setPath(copy, path) {
  if (typeof copy === "string" && copy.includes("%PATH%")) {
    return copy.replace(/%PATH%/, path);
  }
  return copy;
}

export default function Footer({ isJP, locale }) {
  const { footer: copy } = useContext(Language);
  return (
    <>
      <Container id="footer">
        <Logo />
        <Disclaimer
          isJP={isJP}
          dangerouslySetInnerHTML={{
            __html:
              setPath(copy.disclaimer, `/${locale}/benefits/diningbenefit/`) ||
              "",
          }}
        ></Disclaimer>
      </Container>
    </>
  );
}
